<template>
  <div id="print-page">
    <notify-bar class="notify-bar" @click="toPrintNotice"/>
    <div id="promote-tip">
      <div id="pt1">满&nbsp;减</div>
      <div id="pt2">满2版享8折，满3版及以上享7折</div>
    </div>
    <div class="box" id="address">
      <router-link id="add-addr"
                   class="center"
                   tag="div"
                   :to="{name: 'addressManage'}"
                   v-if="!addressInfo">
        <icon-plus class="icon-plus"/>
        <span>添加收货地址</span>
      </router-link>
      <router-link v-else
                   id="change-addr"
                   tag="div"
                   :to="{name: 'addressManage'}">
        <div id="addressInfo">
          <div id="line1" class="font-2" style="word-break: break-all;">
            <span>{{ addressInfo.userName }}</span>
            <span id="info-tel">{{ addressInfo.userTel}}</span>
          </div>
          <div id="line2">{{addressInfo.addressValue + addressInfo.detailAddr}}</div>
        </div>
        <img src="../assets/right-chevron.png" alt="more" id="arrow">
      </router-link>
    </div>
    <div class="box" id="preview">
      <div class="boxbg">
        <print-list @calcNum="calcNum" @previewImg="previewImg" :printQty="userInput.printQty" :sheets_number="printInfo.sheets_number" :singlePrice="singelePrice" :image_url="showUrl" :spec_name="printInfo.spec_name"></print-list>
      </div>
      <div class="boxbg" id="value-added-box" v-if="formBol">
          <div class="form-container" @click="changeFormalWear">
          <div class="_wrap">
            <div class="form-title">增值服务：</div>
            <div class="form-body">
              <div class="check-label">
                个性换正装
                <span class="highlight">
                <span class="yuan">¥</span>{{formprice}}
              </span>
              </div>
            </div>
          </div>

          <circle-checkbox :checked="selType==='formal'"/>
        </div>
      </div>
    </div>
    <!-- <div class="box" id="info-area">
      <div id="u-price">
        <div class="font-2">单价：</div>
        <div class="font-6">¥</div>
        <div id="price-number2">{{singelePrice}}</div>
      </div>
      <cell :cellName="`冲印版数（1版${printInfo.sheets_number}小张）：`">
        <div slot="value" id="num-selector-container">
          <div class="num-selector">
            <div class="num-ctrl" @click="calcNum(-1)">-</div>
            <div class="num">{{userInput.printQty}}</div>
            <div class="num-ctrl" @click="calcNum(1)">+</div>
          </div>
          <div>版</div>
        </div>
      </cell>
    </div> -->
    <extra-add :singlePrice="singelePrice" @previewImg="previewImg"></extra-add>
    <div class="box" id="user-input">
      <div class="form-container">
        <div class="form-title">配送方式（全国包邮）</div>
        <div class="form-body">
          <div class="radio-cell" v-for="item in priceList" :key="item.name">
            <label class="cell-label">
              <span class="_left">
                <input type="radio"
                       class="radio-input"
                       :value="item.type"
                       @click="checkPrice(item.type)"
                       v-model="userInput.expressType">
                <span class="radio-check-icon"></span>
                <span class="radio-label">{{item.name}}</span>
              </span>
              <span class="time">{{item.hint}}</span>
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="price-bar">
      <div class="price-info">
        <div class="main-info">
          应付款：
          <span class="price-unit">¥</span>
          <span class="price-number">{{needToPay}}</span>
        </div>
        <div class="sub-info">
          <template v-if="+priceOff">
            已优惠：
            <span class="price-unit">¥</span>
            <span class="price-number">{{priceOff}}</span>
          </template>
          <template v-else>
            <span style="color: rgba(116, 116, 116, 1)">无优惠</span>
          </template>
        </div>
      </div>
      <button class="submit" @click="submit">提交冲印订单</button>
    </div>
    <transition name="fade">
      <div class="preview-box" v-show="showPreviewImg" @click="previewImg(false)">
        <img :src="bigurl" />
      </div>
    </transition>
    <mt-popup v-model="notifyShow"
              :modalFade="true"
              :lockScroll="true"
              :close-on-click-modal="true"
              popup-transition="popup-fade"
              :modal="true">
      <div class="notify-box">
        <div class="_top">
          <h3 class="_title">{{notifyText['title']}}</h3>
         <p class="_main _confirm" style="word-break: break-all;white-space: pre-wrap;">{{notifyText['content']}}</p>
        </div>
        <div class="foot">
          <button class="confirm-btn" @click="notifyShow=false">我知道了</button>
        </div>
      </div>
    </mt-popup>
  </div>
</template>

<script>
  import {Toast, Popup} from 'mint-ui'
  import Moment from 'moment'
  import {STORAGE_CURR_ADDR} from '../utils/const'
  import {calcMul, calcAdd, calcSub, getDateAfterNDay} from '../utils/utils.js'
  import { mapState, mapMutations, mapActions } from "vuex";
  import printList from "@/components/printList";
  import extraAdd from "@/components/ExtraAdd";
  import NotifyBar from '../components/NotifyBar'
  import IconPlus from "../components/Icon/IconPlus";
  import CircleCheckbox from "../components/CircleCheckbox";
  export default {
    name: 'Print',
    components: {CircleCheckbox, IconPlus, NotifyBar, [Popup.name]: Popup,printList,extraAdd},
    data() {
      return {
        bigurl:'',
        printPrice:null,
        addressInfo: null,
        userInput: {
          printQty: 1, // 冲印版数
          userName: '',
          userTel: '',
          city: '',
          detailAddr: '',
          expressType: 'normal', // 快递方式
        },
        deliverMode: 'normal',
        priceList: [{
          name: '普通快递',
          type: 'normal',
          hint: '',
        }, {
          name: '加急快递',
          type: 'urgent',
          hint: '',
        }],
        selType: '',
        showPreviewImg: false,
        notifyShow: false,
        notifyText: '',
      };
    },

    created() {
    },
    activated() {
      let addressInfo = JSON.parse(localStorage.getItem(STORAGE_CURR_ADDR));
      console.log("processedPhoto:::",this.processedPhoto)
      this.addressInfo = addressInfo;
      if(!this.actiBol){
        return;
      }
      this.getPrintprice();
      addressInfo && addressInfo.addressCode && this.getPredictTime(addressInfo.addressCode)
      this.selType = this.formBol ? "formal" : "origin";
    },
    deactivated(){
      if(!this.actiBol){
        this.EXTRAINIT()
      }
    },
    mounted() {
      if (this.printInfo.print_number) {
        this.$set(this.userInput, 'printQty', this.printInfo.print_number)
      }
    },

    methods: {
      ...mapActions(["getPrintPrice","getDivisionTime","createPrintOrder"]),
      ...mapMutations(['UPDATEGROUPLISTPRICE','EXTRAINIT']),
      previewImg(flag=false,url) {
        this.showPreviewImg = flag;
        this.bigurl = url
        document.querySelector('body').style.overflow = flag ? 'hidden' : 'auto';
        document.querySelector('body').style.height = flag ? '100vh' : 'auto';
      },
      toPrintNotice() {
        this.$router.push({
          name: 'printNotice'
        })
      },
      // 勾选换正装服务
      changeFormalWear() {
        if (this.formBol) {
          let val = this.selType;
          this.selType = val === 'formal' ? 'origin' : 'formal';
        } else {
          console.log('current can not change formal Wear: ', this.hasValueAdded)
        }
      },
      getPrintprice(){
        this.getPrintPrice().then(res=>{
          let {data:printPrice} = res;
          this.printPrice=printPrice;
        })
      },
      checkPrice(type = 'normal') {
        this.userInput.expressType = type;
        this.deliverMode = type;
        this.UPDATEGROUPLISTPRICE(this.singelePrice)
      },

      getPredictTime(divisionCode) {
        /**
         * 如果 note 有值，直接返回 note 的值。
         * 如果 deadline 为空，证明当前时间在周六15点后至周末24点前，显示周一发货。
         * 如果 deadline 有值，按照参数返回的具体时间判断下单显示时间。
         * -> 比如 deadline == 2018-01-02T24:00:00Z 就显示24:00 前下单 。
         * 判断 etd 日期是今天等于今天就提示今天发货,日期是明天就明天发货。
         * eta 为预计到达时间，只有用户在有发货仓的省会或者江浙沪才会有值，为预计到达时间的描述判定参数。
         */
        this.getDivisionTime({code:divisionCode}).then(({data}) => {
          let priceList = [...this.priceList];


          const handleShippingHint = ({deadline, eta, etd, note}, type) => {
            let str = ''
            if (note) {
              str = note
            } else {
              if (deadline) {
                let timeStr = Moment(deadline).format('HH:mm')
                if (timeStr === '00:00')
                  timeStr = '今日24:00'
                str = timeStr + '前付款'

                if (etd) {
                  let etdStr = Moment(etd).calendar(null, {sameDay: '[今天]', nextDay: '[明天]'})
                  if (etdStr !== '今天' && etdStr !== '明天') {
                    etdStr = Moment(etd).format('M月D日')
                  }
                  str += `，${etdStr}发货`
                }

                if (eta)
                  str += `，预计${Moment(eta).format('M月D日')}到达`

              } else {
                str = '现在下单，将会在周一发货。'
              }
            }
            priceList.find(item => item.type === type).hint = str;
          }

           ['normal', 'urgent'].forEach(key => {
            handleShippingHint(data[key], key)
          })
           this.$set(this, 'priceList', priceList);
           this.notifyShow = !!data['describe'];
           !!data['describe'] && this.$set(this, 'notifyText', data['describe']);
        })
      },

      submit(arg = '') {
        // validate
        if (!this.addressInfo) return Toast('请填写地址信息');
        if (!/^1[0-9]{10}$/.test(this.addressInfo.userTel))
          return Toast('请输入正确的手机号');
        if (!this.addressInfo.userName)
          return Toast('请输入姓名');
        if (!this.addressInfo.addressCode)
          return Toast('请选择收货城市');
        if (!this.addressInfo.detailAddr)
          return Toast('请输入详细地址');
        // let {type} = this.processedPhoto.picinfo
        let { key:add_order_image_key } = this.printextra
        let add_order_specs = this.grouplist.map(item=>({
          spec_id:item.id,
          colors:(this.ruleColor[item.id])[item.colorIdx],
          quantity:item.printQty,
        }))
        const submitData = {
          "colors": [this.printInfo.colors],
          "origin_name": this.printInfo.origin_name,
          "spec_id" : this.printInfo.spec_id,
          "consignee_name": this.addressInfo.userName,
          "spec_name": this.printInfo.spec_name,
          "consignee_phone": this.addressInfo.userTel,
          "print_number": +this.userInput.printQty,
          "ele_name": this.printInfo[this.selType].serialNumber,
          "is_formal_wear": this.selType === 'formal',
          "delivery": this.userInput.expressType,
          "description": this.printInfo.spec_name,
          "quantity": +this.userInput.printQty,
          "user_name": this.addressInfo.userName,
          "user_phone": this.addressInfo.userTel,
          "user_address_division": this.addressInfo.addressCode,
          "user_address_detail": this.addressInfo.detailAddr,
          "extra":this.printextra,
          ...add_order_image_key&&{add_order_image_key},
          ...add_order_specs.length>0&&{add_order_specs}
        };
        console.log("submitData:::",submitData);
        this.createPrintOrder(submitData).then(()=>{
          this.$router.replace({name: 'OrderList',query: {state: 'waiting'}})
        })
      },

      calcNum(num) {
        const currentQty = this.userInput.printQty;
        if (currentQty >= 20 && +num > 0) return Toast('不能再多啦！');
        if (currentQty <= 1 && +num < 0) return Toast('亲，不能再少啦！');

        this.$set(this.userInput, 'printQty', currentQty + +num);
      },

      // async getPrice() {
      //   if (!this.printPrice) {
      //     let priceRes = await getPrintPrice();
      //     this.RECORD_PRINTPRICE(priceRes.data.result);
      //   }
      //   // this.checkPrice(deliverMode)
      // },
    },

    computed: {
      ...mapState(["printInfo","actiBol","processedPhoto","grouplist","printextra","ruleColor"]),
      singelePrice() {
        return this.printPrice?+((this.printPrice[this.deliverMode]/100).toFixed(2)):0;
      },
      groupNum() {
        return this.grouplist.reduce((sum,item)=>{
          return sum+item.printQty
        },0)
      },
      totalNum() {
        return calcAdd(this.groupNum,this.userInput.printQty)
      },
      formprice() {
        return this.printPrice?(this.printPrice.formal_wear_price)/100:"计算中";
      },
      discount() {
        if (this.totalNum == 2) return 0.8;
        if (this.totalNum > 2) return 0.7;
        return 1
      },

      totalPrice() {
        return calcMul(this.totalNum, this.singelePrice)
      },

      needToPay() {
        let val = calcMul(this.totalPrice, this.discount);
        return this.formBol && this.selType === 'formal' ? calcAdd(val,this.formprice) : val;
      },

      priceOff() {
        let np = this.formBol && this.selType === 'formal' ? calcSub(this.needToPay, this.formprice) : this.needToPay;
        return calcSub(this.totalPrice, np);
      },
      formBol() {
        return this.printInfo.formal ? true : false;
      },
      showUrl() {
        return this.selType &&this.printInfo[this.selType] && this.printInfo[this.selType].imageUrl;
      }
    },

    watch: {
      addressInfo: {
        deep: true,
        handler(newval,oldval) {
          console.log('haha')
          console.log(oldval,newval)
          newval && (!oldval||newval.addressCode !== oldval.addressCode) && this.getPredictTime(newval.addressCode)
          // if (val.addressCode) {
          //   // 获取估算时间
          //   this.getPredictTime(val.addressCode)
          // }
        }
      },
    },
  };
</script>

<style lang="scss" scoped>

  @import "../style/index";
  .oneline{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .flexwrap{
    display: flex;
  }
  #print-page {
    .notify-bar {
      border-bottom: 1.5px solid #648AD8;
    }

    #promote-tip {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      padding:8px 16px;
      align-items: center;
      line-height: 1em;
      #pt1 {
        width: 0.37rem;
        height: 0.15rem;
        background-color: #f63d30;
        font-size: 0.1rem;
        color: #ffffff;
        line-height: 0.13rem;
        display: table;
        border-radius: 3px;
        overflow: hidden;
        text-align: center;
        line-height: 0.15rem;
      }

      #pt2 {
        font-size: 0.12rem;
        color: #747474;
        margin-left: 0.08rem;
        line-height: 0.12rem;
      }
    }

    #value-added-box {
      .form-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .form-title {
        font-weight: bold;
        padding:0;
        margin-bottom: .12rem;
      }
      .form-body {
        background-color: transparent;
        display: flex;
        align-items: center;

        .check-label {
          font-size: 0.14rem;

          .highlight {
            font-size: 0.16rem;
            color: #F63D30;
            font-weight: bold;

            .yuan {
              font-size: 0.12rem;
              font-weight: normal;
            }
          }
        }
      }
    }

    #preview {
      margin-top: 0.14rem;
      box-sizing: border-box;
      padding:12px 16px;
      .boxbg{
        box-sizing: border-box;
        padding:14px 23px;
        background-color: #F8FAFE;
        border-radius: 5px;
        margin-top: 8px;
        &:first-child{
          margin-top: 0;
        }
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    #arrow {
      width: 0.09rem;
      height: 0.16rem;
    }

    #addressInfo {
      width: 2.69rem;

      #line2 {
        font-size: 0.12rem;
        font-weight: 400;
        color: rgba(110, 110, 110, 1);
        margin-top: 0.07rem;
        word-break: break-all;
      }
    }

    #add-addr {
      height: 0.64rem;
      font-size: 0.16rem;
      font-weight: 400;
      color: rgba(135, 135, 135, 1);

      .icon-plus {
        margin-right: 0.04rem;
        margin-top: 0.02rem;
      }
    }

    #change-addr {
      padding: 0.15rem 0.24rem 0.1rem 0.16rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    #info-tel {
      margin-left: 0.18rem;
    }

    #user-input {
      margin-bottom: 0.73rem;

      .form-title {
        margin-left: 0.08rem;
        font-weight: bold;
      }

      .form-body {
        padding: 0 0.08rem 0.15rem;
        background-color: transparent;

        .radio-cell {
          background-color: $form-bg;

          .radio-label {
            font-size: 0.12rem;
          }

          .time {
            font-size: 0.1rem;
          }

          & + .radio-cell {
            border-top: 1px solid rgba(151, 151, 151, 0.15);
          }
        }
      }
    }

    .radio-input:checked + .radio-check-icon {
      background-image: url('../assets/selected-radio.png');
    }

    .cell-label {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-right: 0.08rem;
      padding-left: 0.06rem;

      ._left {
        display: flex;
        align-items: center;
        flex-shrink: 0;
      }

      .radio-check-icon {
        margin-right: 0.04rem;
        width: 0.16rem;
        height: 0.16rem;
        box-sizing: border-box;
        background-image: url('../assets/unselect-radio.png');
        background-repeat: no-repeat;
        background-size: contain;
        flex-shrink: 0;
      }

      .radio-label {
        font-size: 0.14rem;
        color: #363636;
        flex-shrink: 0;
      }

      .time {
        font-size: 0.14rem;
        color: #747474;
        margin-left: 0.04rem;
      }
    }

    .radio-cell {
      padding: 0.14rem 0;
    }
  }
  .preview-box {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgb(0, 0, 0);
    z-index: 200;
    display: flex;
    align-items: center;

    &::before {
      content: '';
      position: absolute; z-index: 10;
      left: 0; top: 0;
      width: 100%; height: 100%;
    }

    img {
      width: 100%;
    }
  }

  .fade {
    &-enter, &-leave-to { opacity: 0; }
    &-enter-active, &-leave-active { transition: opacity 200ms ease; }
    &-enter-to, &-leave { opacity: 1; }
  }
</style>
